/**
 * The first twelve characters of a commit, which is what a human compares.
 *
 * Duplicated from `apps/api/src/build-info.ts` rather than imported: the web
 * app deliberately does not depend on `@savi/api` at run time, and this is
 * four lines against a package boundary.
 */
export function shortSha(sha: string): string {
  return sha === "unknown" ? sha : sha.slice(0, 12);
}
